import { asNumber, asString } from '../http/normalise';
import { ApiDocumentCategory } from './document-category.dto';
import { DocumentCategory } from './document-category.model';

export function mapDocumentCategory(
  dto: ApiDocumentCategory
): DocumentCategory {
  return {
    id: asString(dto.id) ?? '',
    eventId: asString(dto.eventId) ?? '',
    label: asString(dto.label) ?? '',
    documentCount: asNumber(dto.documentCount) ?? 0,
  };
}
